import React, { useState, useEffect } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";

const questions = [
  { filled: 25, correct: 0.25 },
  { filled: 50, correct: 0.5 },
  { filled: 75, correct: 0.75 },
  { filled: 20, correct: 0.2 },
  { filled: 90, correct: 0.9 }
];

const ColorBlocksGame = () => {
  const [current, setCurrent] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [showNext, setShowNext] = useState(false);
  const [options, setOptions] = useState([]);

  const question = questions[current];

  useEffect(() => {
    generateOptions();
    setFeedback('');
    setShowNext(false);
  }, [current]);

  const generateOptions = () => {
    const correct = question.correct;
    const values = [correct];
    while (values.length < 3) {
      const rand = +(Math.random().toFixed(2));
      if (!values.includes(rand) && rand !== 0) values.push(rand);
    }
    values.sort(() => Math.random() - 0.5);
    setOptions(values);
  };

  const checkAnswer = (selected) => {
    if (selected === question.correct) {
      setFeedback('✅ Correct!');
      setShowNext(true);
    } else {
      setFeedback('❌ Try again!');
    }
  };

  const nextQuestion = () => {
    if (current + 1 < questions.length) {
      setCurrent(current + 1);
    } else {
      setFeedback('🎉 You finished all the questions!');
      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
      setOptions([]);
    }
  };

  const styles = {
    container: {
      fontFamily: "'Comic Sans MS', cursive",
      background: '#e0f7fa',
      textAlign: 'center',
      padding: '2rem 1rem',
      minHeight: '100vh',
      boxSizing: 'border-box'
    },
    title: {
      color: '#00796b',
      fontSize: 'clamp(1.5rem, 5vw, 2.5rem)',
      marginBottom: '0.5rem'
    },
    subtitle: {
      fontSize: 'clamp(1rem, 3.5vw, 1.3rem)',
      marginBottom: '1.5rem'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(10, 1fr)',
      gap: '2px',
      maxWidth: '240px',
      margin: '0 auto 1.5rem'
    },
    block: {
      aspectRatio: '1',
      width: '100%',
      backgroundColor: '#fff',
      border: '1px solid #ccc'
    },
    filled: {
      backgroundColor: '#4db6ac'
    },
    optionContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: '10px',
      marginBottom: '1rem'
    },
    optionBtn: {
      padding: '10px 20px',
      backgroundColor: '#009688',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      fontSize: 'clamp(1rem, 3.5vw, 1.2rem)',
      minWidth: '100px'
    },
    feedback: {
      marginTop: '1rem',
      fontSize: 'clamp(1rem, 3.5vw, 1.2rem)',
      fontWeight: 'bold',
      color: feedback.startsWith('✅') ? '#2e7d32' : '#c62828',
      minHeight: '1.5em'
    },
    nextBtn: {
      display: showNext ? 'inline-block' : 'none',
      marginTop: '1rem',
      padding: '10px 20px',
      backgroundColor: '#00796b',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: 'clamp(1rem, 3.5vw, 1.2rem)',
      cursor: 'pointer'
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>🎨 Color the Blocks</h1>
      <p style={styles.subtitle}>Select the decimal that matches the colored fraction grid:</p>

      <div style={styles.grid}>
        {Array.from({ length: 100 }, (_, i) => (
          <div
            key={i}
            style={{
              ...styles.block,
              ...(i < question.filled ? styles.filled : {})
            }}
          />
        ))}
      </div>

      <div style={styles.optionContainer}>
        {options.map((val, idx) => (
          <button
            key={idx}
            style={styles.optionBtn}
            onClick={() => checkAnswer(val)}
          >
            {val.toFixed(2)}
          </button>
        ))}
      </div>

      <div style={styles.feedback}>{feedback}</div>

      <button style={styles.nextBtn} onClick={nextQuestion}>
        Next ➡
      </button>
    </div>
  );
};

export default ColorBlocksGame;
